<template>
  <div class="change-password-view">
    <div class="container is-max-desktop">
      <div class="box">
        <p class="title is-3">
          {{ changeOwnPassword ? 'Skift Password' : `Skift Password for ${this.appUser.name}` }}
        </p>

        <div class="columns"
             v-if="changeOwnPassword">
          <b-field label="Gammelt Password"
                   class="column">
            <b-input type="password"
                     v-model="formChangePassword.oldPassword"
                     password-reveal></b-input>
          </b-field>
        </div>

        <div class="columns">
          <b-field label="Nyt Password"
                   class="column">
            <b-input type="password"
                     v-model="formChangePassword.newPassword"
                     password-reveal></b-input>
          </b-field>
        </div>

        <div class="columns">
          <b-field label="Gentag Nyt Password"
                   class="column">
            <b-input type="password"
                     v-model="formChangePassword.newPasswordRepeat"
                     password-reveal></b-input>
          </b-field>
        </div>

        <div class="form-controls">
          <b-button @click="goBack">
            Afbryd
          </b-button>
          <b-button @click="changePassword"
                    type="is-primary"
                    :loading="loading">
            Skift Password
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ApiState from "../enums/APISTATE";

export default {
  name: "change-password-view",
  props: {
    userId: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    formChangePassword: {},
  }),
  async mounted() {
    try {
      await this.loadMyUser();
      if (this.userId !== null) {
        await this.loadAppUser(this.userId);
      }
    } catch (error) {
      console.error(error);
    }
  },
  methods: {
    ...mapActions("appUsers", [
      "loadAppUser",
      "loadMyUser",
      "setAppUserPassword",
    ]),
    async changePassword() {
      if (this.changeOwnPassword) {
        await this.setAppUserPassword({
          id: this.myAppUser.id,
          form: this.formChangePassword,
        });
      } else {
        await this.setAppUserPassword({
          id: this.userId,
          form: this.formChangePassword,
        });
      }
      if (this.appUserApiState !== ApiState.ERROR) {
        this.$buefy.dialog.confirm({
          title: "Success",
          message: `Kodeord ændret`,
          type: "is-success",
          canCancel: false,
          onConfirm: () => this.goBack(),
        });
      } else {
        this.$buefy.dialog.alert({
          title: "Fejl",
          message: "Kunne ikke opdatere kodeord",
          type: "is-danger",
        });
      }
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  computed: {
    ...mapGetters("appUsers", ["appUser", "myAppUser", "appUserApiState"]),
    changeOwnPassword() {
      return this.userId === null;
    },
    loading() {
      return this.appUserApiState === ApiState.LOADING;
    },
  },
};
</script>

<style lang="scss" scoped>
.change-password-view {
  .form-controls {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
}
</style>